import store from "../reducers/store";

export default function authHeader() {

    let me = JSON.parse(localStorage.getItem("reduxState"));

    if (me == undefined) {
        return "";
    }

    return { Authorization: `Bearer ${me.auth.token}` };
}
